import $ from "jquery";
import CookieConsent from "@alpaga/cookie-consent";
$(document).ready(function () {
    var lang = $("html").attr("lang") == "nl-BE" ? "nl" : "fr";
    $('.footer-nav').append("<li><a href='#cookies' class='Button cookies'>" + (lang == "nl" ? "Cookies instellingen" : "Modifier les cookies") + "</a></li>");
    var cookies = {
        fr: {
            locale: "fr",
            content: {
                link: "/fr/cookie-privacy/",
                banner: {
                    title: "En utilisant ce site, vous acceptez l'utilisation des cookies."
                },
                popup: {
                    title: "Ce site utilise des cookies.",
                    description: "Ce site utilise des cookies. Nous utilisons des cookies pour que notre site web fonctionne au mieux, améliorant ainsi votre expérience en ligne. Afin d’en savoir plus sur l’utilisation des cookies, les plug-ins pour les réseaux sociaux ainsi que le web tracking, n’hésitez pas à consulter notre page d’informations sur les Cookies ainsi que notre Déclaration de Protection des Données."
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Cookies nécessaires",
                    description: "Les cookies nécessaires aident à rendre un site Web utilisable en activant de base \
                    des fonctions telles que la navigation sur les pages et l'accès aux zones sécurisées du site Web. Le site Web ne peut pas \
                    fonctionner correctement sans ces cookies.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "cookieconsent.extension",
                            purpose: "Stocke l'état de consentement des cookies de l'utilisateur pour le domaine actuel",
                            expiry: "1 an",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: false,
                    title: "Analytics Cookies",
                    "function": function () {
                        activateTracking();
                    },
                    description: "Les cookies analytiques aident les propriétaires de sites Web à comprendre comment les visiteurs \
                    interagir avec les sites Web en collectant et en signalant des informations de manière anonyme.",
                    cookies: [
                        {
                            name: "_dc_gtm_UA-#",
                            provider: "Google Tag Manager",
                            purpose: "Utilisé pour charger Google Analytics.",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "2 ans",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Utilisé par Google Analytics pour réduire le taux de demandes",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Enregistre un identifiant unique utilisé pour générer des données statistiques sur la façon dont le visiteur utilise le site Web.",
                            expiry: "1 jour",
                            type: "HTTP"
                        }
                    ]
                },
                some: {
                    name: "some",
                    value: false,
                    title: "Cookies 'Réseaux sociaux'",
                    "function": function () {
                        activateMarketing();
                    },
                    description: "Ces cookies sont activés par les services proposés sur les réseaux sociaux que nous avons ajoutés au site Web afin de vous donner la possibilité de partager notre contenu avec votre réseau et vos connaissances. Ils nous permettent également de suivre votre navigation sur d’autres sites Web et d’établir un profil de vos intérêts. Cela peut avoir un impact sur le contenu et les messages affichés sur les autres sites Web que vous consultez. Si vous n'autorisez pas ces cookies, il se peut que vous ne puissiez pas utiliser ou visualiser ces outils de partage.",
                    cookies: [
                        {
                            name: "_fbp",
                            provider: "Facebook",
                            purpose: " Utilisé par Facebook pour fournir une série de produits publicitaires, tels que des offres en temps réel d'annonceurs externes",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "lang",
                            provider: "Linkedin",
                            purpose: "Utilisé par Linkedin pour garder une trace de la session de langue sélectionnée par l'utilisateur",
                            expiry: "Session",
                            type: "HTTP"
                        },
                        {
                            name: "bcookie",
                            provider: "Linkedin",
                            purpose: "Utilisé par Linkedin pour mesurer les intégrations Linkedin pendant",
                            expiry: "2 ans",
                            type: "HTTP"
                        },
                        {
                            name: "bscookie",
                            provider: "Linkedin",
                            purpose: "Utilisé par Linkedin pour mesurer les intégrations Linkedin",
                            expiry: "2 ans",
                            type: "HTTP"
                        },
                        {
                            name: "lidc",
                            provider: "Linkedin",
                            purpose: "Utilisé par Linkedin pour optimiser les impressions d'annonces",
                            expiry: "1 jour",
                            type: "HTTP"
                        },
                        {
                            name: "UserMatchHistory",
                            provider: "Linkedin",
                            purpose: "Utilisé par Linkedin pour optimiser les impressions d'annonces pendant",
                            expiry: "29 jours",
                            type: "HTTP"
                        },
                    ]
                }
            }
        },
        nl: {
            locale: "nl",
            labels: {
                showCookie: "Laat cookies zien",
                table: {
                    name: "Naam",
                    provider: "Provider",
                    purpose: "Doel",
                    expiry: "Verloopt op",
                    type: "Type"
                },
                "switch": {
                    on: "Ja",
                    off: "Nee"
                },
                actions: {
                    more: "Meer weten?",
                    allow: {
                        all: "Accepteer alle cookies",
                        selected: "Accepteer alle geselecteerde cookies"
                    },
                    read: {
                        policy: "Lees ons cookiebeleid"
                    },
                    cancel: "Cancel",
                    view: {
                        advanced: "Geavanceerde keuze",
                        simple: "Eenvoudige keuze"
                    }
                }
            },
            content: {
                link: "/nl/cookie-policy",
                banner: {
                    title: "Door deze site te gebruiken, gaat u akkoord met het gebruik van cookies."
                },
                popup: {
                    title: "Deze website maakt gebruik van cookies.",
                    description: "Deze cookies zorgen ervoor dat u de beste ervaring op onze website krijgt. Door te klikken op ‘Begrepen!’ gaat u akkoord met onze cookie en privacy policy. Wenst u meer informatie?"
                }
            },
            cookies: {
                'necessary': {
                    name: "necessary",
                    disabled: true,
                    value: true,
                    title: "Strikt noodzakelijke cookies",
                    description: "Deze cookies zijn nodig anders werkt de website niet. Deze cookies kunnen niet worden uitgeschakeld. In de meeste gevallen worden deze cookies alleen gebruikt naar aanleiding van een handeling van u waarmee u in wezen een dienst aanvraagt, bijvoorbeeld uw privacyinstellingen registreren, in de website inloggen of een formulier invullen. U kunt uw browser instellen om deze cookies te blokkeren of om u voor deze cookies te waarschuwen, maar sommige delen van de website zullen dan niet werken. Deze cookies slaan geen persoonlijk identificeerbare informatie op.",
                    "function": function () { },
                    cookies: [
                        {
                            name: "CookieConsent",
                            provider: "cookieconsent.extension",
                            purpose: "Slaat de cookiestatus van de gebruiker op voor het huidige domein",
                            expiry: "1 jaar",
                            type: "HTTP"
                        },
                    ]
                },
                analytics: {
                    name: "analytics",
                    value: false,
                    title: "Analytics Cookies",
                    "function": function () {
                        activateTracking();
                    },
                    description: "Analytische cookies helpen website-eigenaren te begrijpen hoe bezoekers \
                    interactie met websites door anoniem informatie te verzamelen en te rapporteren.",
                    cookies: [
                        {
                            name: "_dc_gtm_UA-#",
                            provider: "Google Tag Manager",
                            purpose: "Wordt gebruikt om Google Analytics te laden.",
                            expiry: "1 dag",
                            type: "HTTP"
                        },
                        {
                            name: "_ga",
                            provider: "Google",
                            purpose: "Registreert een unieke identificatie die wordt gebruikt om statistische gegevens te genereren over hoe de bezoeker de website gebruikt.",
                            expiry: "2 jaar",
                            type: "HTTP"
                        },
                        {
                            name: "_gat",
                            provider: "Google",
                            purpose: "Gebruikt door Google Analytics om de verzoeksnelheid te verlagen",
                            expiry: "1 dag",
                            type: "HTTP"
                        },
                        {
                            name: "_gid",
                            provider: "Google",
                            purpose: "Registreert een unieke identificatie die wordt gebruikt om statistische gegevens te genereren over hoe de bezoeker de website gebruikt.",
                            expiry: "1 dag",
                            type: "HTTP"
                        }
                    ]
                },
                some: {
                    name: "some",
                    value: false,
                    title: "Cookies 'Social network'",
                    "function": function () {
                        activateMarketing();
                    },
                    description: "Deze cookies worden geactiveerd door de diensten die worden aangeboden op sociale netwerken die we aan de website hebben toegevoegd om u de mogelijkheid te geven onze inhoud te delen met uw netwerk en kennissen. Ze stellen ons ook in staat om uw browsen op andere websites te volgen en een profiel van uw interesses op te bouwen. Dit kan van invloed zijn op de inhoud en berichten die worden weergegeven op andere websites die u bezoekt. Als u deze cookies niet toestaat, kunt u deze tools voor delen mogelijk niet gebruiken of bekijken.",
                    cookies: [
                        {
                            name: "_fbp",
                            provider: "Facebook",
                            purpose: "Gebruikt door Facebook om een ​​verscheidenheid aan advertentieproducten te leveren, zoals realtime aanbiedingen van externe adverteerders",
                            expiry: "1 dag",
                            type: "HTTP"
                        },
                        {
                            name: "lang",
                            provider: "Linkedin",
                            purpose: "Gebruikt door Linkedin om de taalsessie bij te houden die door de gebruiker is geselecteerd",
                            expiry: "Sessie",
                            type: "HTTP"
                        },
                        {
                            name: "bcookie",
                            provider: "Linkedin",
                            purpose: "Gebruikt door Linkedin om Linkedin-integraties te meten tijdens",
                            expiry: "2 jaar",
                            type: "HTTP"
                        },
                        {
                            name: "bscookie",
                            provider: "Linkedin",
                            purpose: "Gebruikt door Linkedin om Linkedin-integraties te meten",
                            expiry: "2 jaar",
                            type: "HTTP"
                        },
                        {
                            name: "lidc",
                            provider: "Linkedin",
                            purpose: "Gebruikt door Linkedin om advertentievertoningen te optimaliseren",
                            expiry: "1 dag",
                            type: "HTTP"
                        },
                        {
                            name: "UserMatchHistory",
                            provider: "Linkedin",
                            purpose: "Gebruikt door Linkedin om advertentievertoningen te optimaliseren",
                            expiry: "29 dagen",
                            type: "HTTP"
                        },
                    ]
                }
            }
        }
    };
    var CookieConsentNode = new CookieConsent(cookies[lang]);
    CookieConsentNode.init();
    var viewCookieBannerButton = document.querySelector(".cookies.Button");
    if (viewCookieBannerButton !== void 0) {
        viewCookieBannerButton.addEventListener("click", function (e) {
            e.preventDefault();
            CookieConsentNode.showDetails();
        });
    }
});
